var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrevious(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "14.25 13 21.5 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/video/prev",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeOpacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(16.000000, 15.000000)",
    className: "svg-stroke",
    stroke: "#FFFFFF",
    strokeWidth: 1.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.65,1.06978534 L0.65,18.9093202 C0.65,19.4023713 0.748830385,19.460751 1.16231777,19.2401212 L16.6172439,10.3312186 C17.0382545,10.0863441 17.0382545,9.94163555 16.6190427,9.70067919 L1.16173428,0.776208024 C0.752967848,0.540012054 0.65,0.601062684 0.65,1.06978534 Z",
    id: "Shape",
    transform: "translate(8.791682, 10.000000) scale(-1, 1) translate(-8.791682, -10.000000) "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevious);
export default __webpack_public_path__ + "static/media/previous.09cbf1dd8b0a8f93b9957690e12c3945.svg";
export { ForwardRef as ReactComponent };